import { Divider, VStack, View } from "@gluestack-ui/themed";
import { SimulateReceiptController } from "./controller";
import { StoreInfoSection } from "@repo/core/components/receipt/sections/StoreInfoSection";
import { ClientInfoSection } from "@repo/core/components/receipt/sections/ClientInfoSection";
import { ReceiptFooterSection } from "@repo/core/components/receipt/sections/ReceiptFooterSection";
import { Button } from "@repo/core/components/core/Button";
import { SimulatedConditionsSection } from "@repo/core/components/receipt/sections/SimulatedConditionsSection";
import { ShareButton } from "@repo/core/components/core/ShareButton";
import { formatDate } from "@repo/core/utils/date.utils";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const SimulateReceipt = () => {
  const {
    isMobile,
    handleGoToWithdraw,
    selectedInstallmentOption,
    profileData,
    viewRef,
    handleCaptureAndGeneratePDF,
    isLoading,
    selectedStore,
    handleGoToSales
  } = SimulateReceiptController();
  return (
    <Scaffolds.Root
      title="Consulta Valores de Parcelas"
      rightIcon="times"
      onPressRightIcon={handleGoToSales}
      rightWebLabel="Fechar"
      statusBarVariant={StatusBarVariantEnum.LIGHT}
    >
      <Scaffolds.Form
        footerContent={
          <View
            w="$full"
            gap="$4"
            pt={isMobile ? "$4" : "$12"}
            px={isMobile ? "$6" : "$0"}
            pb="$4"
            justifyContent="flex-end"
            flexDirection={!isMobile ? "row-reverse" : "column"}
          >
            <Button
              flex={isMobile ? undefined : 1}
              size="xl"
              action="primary"
              text="Continuar para compra"
              onPress={handleGoToWithdraw}
            />
            <ShareButton
              flex={isMobile ? undefined : 1}
              isLoading={isLoading}
              onPress={handleCaptureAndGeneratePDF}
            />
          </View>
        }
      >
        <View flex={1} ref={viewRef} collapsable={false}>
          <VStack px="$6">
            <SimulatedConditionsSection
              installmentValue={selectedInstallmentOption.dblValorPrestacao}
              interestPercentage={selectedInstallmentOption.dblTaxaMes}
              interestValue={
                selectedInstallmentOption.intPrazo *
                  selectedInstallmentOption.dblValorPrestacao -
                selectedInstallmentOption.dblValorCompra
              }
              iof={selectedInstallmentOption.dblValorIof}
              value={selectedInstallmentOption.dblValorCompra}
              cet={selectedInstallmentOption?.dblCetMes}
              totalValue={
                selectedInstallmentOption.dblValorPrestacao *
                selectedInstallmentOption.intPrazo
              }
              installmentsQuantity={selectedInstallmentOption.intPrazo}
            />
          </VStack>
          <Divider />
          <VStack px="$6">
            <ClientInfoSection
              name={profileData.strNomePortador}
              title="Cliente"
              icon="circle-user"
            />
          </VStack>
          <Divider />
          <VStack px="$6">
            <StoreInfoSection
              name={selectedStore?.descrLoja ?? ""}
              icon="list"
              title="Dados Gerais"
              date={formatDate(new Date())}
            />
          </VStack>
          <ReceiptFooterSection transactionId="5661214er5f-25df8-982d-h87u-b2y6e3a6c4f88b" />
        </View>
      </Scaffolds.Form>
    </Scaffolds.Root>
  );
};
export default SimulateReceipt;
